import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { ContentBody } from '@lanl-web/lanl-components';

import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { ContentContainer, NewsCarousel, QuickLinks } from '../../components';

import './index.scss';
import { renderAlert } from '../../utils';

const DefaultTemplate = ({ data, location }) => {
  const {
    directus: { rl_page: page, rl_news: newsStories },
  } = data;

  const title = page[0]?.title ?? '';
  const introduction = page[0]?.introduction ?? '';
  const body = page[0]?.body ?? '';
  const alert = renderAlert();

  return (
    <Layout className='default-template' location={location}>
      <SEO title={title} />

      <ContentContainer
        alert={alert}
        location={location}
        body={introduction}
        title={title}
      >
        <ContentBody body={body} isHTML />
      </ContentContainer>

      <NewsCarousel stories={newsStories} />
      <QuickLinks />
    </Layout>
  );
};

DefaultTemplate.defaultProps = {
  data: {},
};

DefaultTemplate.propTypes = {
  data: PropTypes.shape({
    directus: PropTypes.object,
  }),
  location: PropTypes.object,
};

export const SectionLandingQuery = graphql`
  query ($slug: String!) {
    directus {
      ...newsArticles
      rl_page(filter: { slug: { _eq: $slug } }) {
        title
        introduction
        body
        slug
        template {
          box_groups {
            group {
              ...boxImageLink
              ...boxLinkList
              ...boxCTA
              ...boxBanner
            }
          }
        }
      }
    }
  }
`;

export default DefaultTemplate;
